import { render, staticRenderFns } from "./closeOrderDialog.vue?vue&type=template&id=97b8d6d2&scoped=true"
import script from "./closeOrderDialog.vue?vue&type=script&lang=js"
export * from "./closeOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./closeOrderDialog.vue?vue&type=style&index=0&id=97b8d6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b8d6d2",
  null
  
)

export default component.exports